import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["name"];

  connect() {
    // no-op; proves Stimulus booted when you see this in the console on pages using data-controller
    console.log("HelloController connected");
  }

  greet() {
    const element = this.nameTarget;
    const name = element.value || element.textContent || "world";
    alert(`Hello, ${name}!`);
  }
}
